import Model from './Model'

export default class EducationCategory extends Model {
  resource() {
    return 'education/categories'
  }
}
